import type { InjectionKey } from 'vue'

import mitt from 'mitt'

type EventBusType = (name: string, callback?: () => void) => void
type EventBusEmitType = (name: string, params?: any) => void

export const $busOn = Symbol('$busOn provide/inject key for event bus') as InjectionKey<EventBusType>
export const $busOff = Symbol('$busOff provide/inject key for event bus') as InjectionKey<EventBusType>
export const $busEmit = Symbol('$busEmit provide/inject key for event bus') as InjectionKey<EventBusEmitType>

export const emitter = mitt()
